<script>
export default {
  props: {
    aggregator: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <v-card v-if="aggregator.table && aggregator.headers">
    <v-card-title>{{ aggregator.name }}</v-card-title>
    <v-data-table
      :headers="aggregator.headers"
      :items="aggregator.table"
      hide-default-footer
      disable-pagination
    />
  </v-card>
</template>



// WEBPACK FOOTER //
// src/components/elements/SingleAggregatorTable.vue